import ApplicationStateDana from "@dana/Store/DanaApplicationState";
import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { Cart, GetCartApiParameter, getCart } from "@insite/client-framework/Services/CartService";

interface Props {
    apiParameter: GetCartApiParameter;
    apiResult: Cart;
    errorMessage: string | undefined;
}
type HandlerType = Handler<GetCartApiParameter, Props>;

export const SetParameters: HandlerType = props => {
     
    props.apiParameter = {
        cartId: props.parameter.cartId,
        expand: ['validation','cartLines', 'costCodes', 'hiddenproducts', 'carriers'],
        forceRecalculation: false,
        allowInvalidAddress: true,
        additionalQueryStringParameters: { "IsAnnualReturnsOrder": 'true'},
    };
    const state = props.getState() as ApplicationStateDana;
    props.dispatch?.({
        type: "AnnualReturnsCart/Start",
        isLoading: true,
        loadSuccess: state.annualReturnsCartState?.cart,
    } as any);
}

export const GetUserCarts: HandlerType = async props => {

    const apiResult = await getCart(props.apiParameter);
    props.apiResult = apiResult.cart;
    props.dispatch?.({
        type: "AnnualReturnsCart/LoadResponse",
        cart: props.apiResult,
    } as any);
}

export const SetLoadingOff: HandlerType = props => {
    props.dispatch?.({
        type: "AnnualReturnsCart/End",
        isLoading: false,
        loadSuccess: true,

    } as any);
}

export const chain = [
    SetParameters,
    GetUserCarts,
    SetLoadingOff
];

const loadAnnualReturnsCart = createHandlerChainRunner(chain, "AnnualReturnsCart");
export default loadAnnualReturnsCart;
